import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PropTypes } from 'prop-types';
import { reset, change } from 'redux-form';
import NotFoundPage from 'components/Errors/NotFoundPage';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import {
  accountDataLoad,
  accountCustomerLink,
  accountCustomerUnlink,
  accountFormUnlink,
  accountFormLink,
  clearAccountData
} from 'actions';

import LoadingWrapper from 'components/Common/LoadingWrapper';
import AddAccountCustomerForm from 'components/Account/AddAccountCustomerForm';
import AccountCustomerList from 'components/Account/AccountCustomerList';
import AccountFormList from 'components/Account/AccountFormList';
import AddFormToAccountForm from 'components/Account/AddFormToAccountForm';
import ConfirmModal from 'components/Modals/ConfirmModal';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class Account extends Component {
  static propTypes = {
    permissions: PropTypes.arrayOf(PropTypes.string),
    dispatch: PropTypes.func.isRequired,
    storeAccount: PropTypes.shape(),
    isLoadingData: PropTypes.bool.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    accountDataLoadError: PropTypes.shape({
      code: PropTypes.number,
      message: PropTypes.string
    })

  };

  static defaultProps = {
    permissions: null,
    storeAccount: {
      name: '',
      customers: [],
      forms: []
    },
    accountDataLoadError: null
  };

  constructor(props) {
    super(props);

    this.state = {
      isDeleteFormModalShown: false,
      isDeletingForm: false,
      deleteFormError: null,
      formId: null,
      isUnlinkCustomerModalShown: false,
      isUnlinkingCustomer: false,
      UnlinkCustomerError: null,
      accountId: null
    };
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(accountDataLoad(match.params.id));
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(clearAccountData());
  }

  openUnlinkFormModal = (formId) => {
    this.setState({ isDeleteFormModalShown: true, formId });
  }

  closeUnlinkFormModal = () => {
    this.setState({ isDeleteFormModalShown: false });
  }

  confirmUnlinkForm = () => {
    const { formId } = this.state;
    this.processFormUnlink(formId);
    this.setState({ isDeleteFormModalShown: false });
  }

  openUnlinkCustomerModal = (accountId) => {
    this.setState({ isUnlinkCustomerModalShown: true, accountId });
  }

  closeUnlinkCustomerModal = () => {
    this.setState({ isUnlinkCustomerModalShown: false });
  }

  confirmUnlinkCustomer = () => {
    const { accountId } = this.state;
    this.processCustomerUnlink(accountId);
    this.setState({ isUnlinkCustomerModalShown: false });
  }

  processCustomerLink(addedAccountData) {
    const { dispatch, storeAccount } = this.props;
    dispatch(accountCustomerLink(storeAccount.id, addedAccountData));
    dispatch(reset('addAccountCustomerForm'));
    dispatch(change('addAccountCustomerForm', 'customerId', null));
  }

  processCustomerUnlink(customerId) {
    const { dispatch, storeAccount } = this.props;
    dispatch(accountCustomerUnlink(storeAccount.id, customerId));
  }

  processFormUnlink(formId) {
    const { dispatch, storeAccount } = this.props;
    dispatch(accountFormUnlink(storeAccount.id, formId));
  }

  processFormLink(formId) {
    const { dispatch, storeAccount } = this.props;
    dispatch(accountFormLink(storeAccount.id, formId));
    dispatch(reset('addFormToAccountForm'));
    dispatch(change('addFormToAccountForm', 'formId', null));
  }

  render() {
    const { permissions, storeAccount, isLoadingData, accountDataLoadError } = this.props;
    const {
      isDeleteFormModalShown,
      isDeletingForm,
      deleteFormError,
      isUnlinkCustomerModalShown,
      isUnlinkingCustomer,
      UnlinkCustomerError
    } = this.state;
    return (
      <div className="container account-panel">

        { accountDataLoadError && (accountDataLoadError.code !== 0
          && <NotFoundPage caption={ accountDataLoadError.message } />
        ) }

        { !accountDataLoadError && (isLoadingData || storeAccount == null) && <LoadingWrapper loaded={ !isLoadingData && storeAccount !== null } />}
        { !accountDataLoadError && !isLoadingData && storeAccount !== null && <div className="panel">
          <div className="panel-header">
            <div className="panel-title">Account: { storeAccount ? storeAccount.accountNumber : '' } - { storeAccount ? storeAccount.accountName : '' }</div>
          </div>
          <div className="panel-body">
            <div className="panel-body-caption no-shrink">
              <p>You can review and edit the Account tax documents and Customer links on this page.</p>
            </div>
            <div className="uploaded-pdfs-caption no-shrink">
              <p>
                You also have the option to unlink tax form(s) from this customer.
              </p>
            </div>
            <div className="panel-body-caption no-shrink">
              <h2><strong>Forms Linked to Account: </strong></h2>
            </div>
            <div className="no-shrink">
              <AccountFormList
                permissions={ permissions }
                account={ storeAccount }
                onConfirmFormUnlink={ accountId => this.openUnlinkFormModal(accountId) }
              />
            </div>
            <AccessControl allowedPermissions={ [ActivityPerms.accountPageEdit] }>
              <div className="panel-body-caption no-shrink">
                <h2><strong>Link a Form: </strong></h2>
              </div>
              <div className="no-shrink">
                <AddFormToAccountForm accountId={ storeAccount && storeAccount.id } onConfirmFormLink={ updateData => this.processFormLink(updateData) } />
              </div>
            </AccessControl>
            <div className="panel-body-caption no-shrink">
              <h2><strong>Customers Linked to Account: </strong></h2>
            </div>
            <div className="no-shrink">
              <AccountCustomerList
                account={ storeAccount }
                onConfirmCustomerUnlink={ accountId => this.openUnlinkCustomerModal(accountId) }
              />
            </div>
            <AccessControl allowedPermissions={ [ActivityPerms.accountPageEdit] }>
              <div className="panel-body-caption no-shrink">
                <h2><strong>Link a Customer: </strong></h2>
              </div>
              <div className="col-8">
                <AddAccountCustomerForm onConfirmCustomerLink={ updateData => this.processCustomerLink(updateData) } />
              </div>
            </AccessControl>
          </div>
        </div> }
        <ConfirmModal
          key="unlinkForm"
          isShown={ isDeleteFormModalShown }
          isPerformingAction={ isDeletingForm }
          onConfirm={ () => this.confirmUnlinkForm() }
          onCancel={ () => this.closeUnlinkFormModal() }
          error={ deleteFormError }
          title="Unlink"
          message="Are you sure you want to unlink this form?"
        />
        <ConfirmModal
          key="UnlinkCustomer"
          isShown={ isUnlinkCustomerModalShown }
          isPerformingAction={ isUnlinkingCustomer }
          onConfirm={ () => this.confirmUnlinkCustomer() }
          onCancel={ () => this.closeUnlinkCustomerModal() }
          error={ UnlinkCustomerError }
          title="Unlink"
          message="Are you sure you want to unlink this customer?"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions
    },
    account: {
      storeAccount,
      isLoadingData,
      accountDataLoadError
    }
  } = state;

  return {
    permissions,
    storeAccount,
    isLoadingData,
    accountDataLoadError
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(Account, 'Account')));
